module.exports = __webpack_public_path__ + "img/Ruecken_farbig.925754d.svg";